import { RouteHttpVerb } from "@devowl-wp/utils";
const locationRestRevisionSecondView = {
    path: "/revision/second-view",
    method: RouteHttpVerb.GET,
    obfuscatePath: "keep-last-part"
};
export { locationRestRevisionSecondView };
